/* eslint-disable @nx/enforce-module-boundaries */
import { Component, inject } from '@angular/core';
import { CommonModule, PlatformLocation } from '@angular/common';
import { ActionItemComponent } from '../shared/action-item.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { version } from '../../../../../package.json';

@Component({
  selector: 'oc-about',
  standalone: true,
  imports: [CommonModule, ActionItemComponent],
  template: ` <div class="modal-container">
    <div class="modal-spacer"></div>
    <div class="modal-body">
      <h1>About</h1>
      <p>
        Oracy Champions by <a href="https://www.webanywhere.com" target="_blank">Webanywhere</a><br />Copyright &copy;
        2025
      </p>
      <p>Version {{ version }}</p>
    </div>
    <div class="modal-spacer">
      <oc-action-item icon="tablerX" size="lg" (click)="activeModal.dismiss('Cross click')"></oc-action-item>
    </div>
  </div>`,
  styles: `
    .modal-container {
      display: flex;
    }

    .modal-body {
      flex: 0;
      flex-basis: 560px;
      padding: 2rem;
    }

    .modal-spacer {
      flex: 1; 
    }

    .modal-spacer:last-child {
      padding: 1.5rem;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
    }

    h1 {
      margin-bottom: 2rem;
    }
  `,
})
export class AboutComponent {
  private platformLocation = inject(PlatformLocation);
  private modalService = inject(NgbModal);
  public activeModal = inject(NgbActiveModal);
  public version = version;

  constructor() {
    this.platformLocation.onPopState(() => this.modalService.dismissAll());
  }

  onAction(confirmed: boolean) {
    this.activeModal.close(confirmed);
  }
}
